import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'

export const colunaTipo = (): TabelaColuna => ({
  Chave: 'tipoMatricula',
  Texto: 'Tipo',
  StyleColuna: { width: 100, paddingInline: 10 },
  Renderizar: (linha: TabelaDados) => <>{linha.tipoMatricula}</>
})
